import { render, staticRenderFns } from "./PostFeedGrid.vue?vue&type=template&id=00a5b69f&"
import script from "./PostFeedGrid.vue?vue&type=script&lang=js&"
export * from "./PostFeedGrid.vue?vue&type=script&lang=js&"
import style0 from "./PostFeedGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports